import { FileModel } from "../../../Shared/dto/create-file-input";

export class CreateProfileInput {
  id?: string;
  companyId?: string;
  picture?: FileModel;
  coverPhoto?: FileModel;
  description?: string;
  phone?: string;
  otherPhone?: string;
  email?: string;
  otherEmail?: string;
  fax?: string;
  registrationDate?: string;
  website?: string;
  otherAddress?: string;
  contactFromFullName?: string;
  contactFromEmail?: string;
  contactFromPhone?: string;
  contactFromAddress?: string;
  contactToFullName?: string;
  contactToEmail?: string;
  contactToPhone?: string;
  contactToAddress?: string;
  contactFromAttachments?: FileModel[];
  contactToAttachments?: FileModel[];
}
